//
// Copyright 2020 DXOS.org
//
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
/**
 * Describes the file dxos/echo/timeframe.proto.
 */
export const file_dxos_echo_timeframe = /*@__PURE__*/ fileDesc("ChlkeG9zL2VjaG8vdGltZWZyYW1lLnByb3RvEhNkeG9zLmVjaG8udGltZWZyYW1lInUKD1RpbWVmcmFtZVZlY3RvchI6CgZmcmFtZXMYASADKAsyKi5keG9zLmVjaG8udGltZWZyYW1lLlRpbWVmcmFtZVZlY3Rvci5GcmFtZRomCgVGcmFtZRIQCghmZWVkX2tleRgBIAEoDBILCgNzZXEYAyABKAVCNFoyZ2l0aHViLmNvbS9keG9zL2R4b3MvcHJvdG8vZGVmL2R4b3MvZWNoby90aW1lZnJhbWViBnByb3RvMw");
/**
 * Describes the message dxos.echo.timeframe.TimeframeVector.
 * Use `create(TimeframeVectorSchema)` to create a new message.
 */
export const TimeframeVectorSchema = /*@__PURE__*/ messageDesc(file_dxos_echo_timeframe, 0);
/**
 * Describes the message dxos.echo.timeframe.TimeframeVector.Frame.
 * Use `create(TimeframeVector_FrameSchema)` to create a new message.
 */
export const TimeframeVector_FrameSchema = /*@__PURE__*/ messageDesc(file_dxos_echo_timeframe, 0, 0);
//# sourceMappingURL=timeframe_pb.js.map